module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"disable":"Отключить","title":"Отключение интеграции с Rabota.ru","text":"После отключения интеграции импорт новых кандидатов с Rabota.ru прекратится. Все уже импортированные кандидаты останутся в Huntica.","cancel":"Отмена"}}')
  delete Component.options._Ctor
}
